import React, { useCallback } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { MenuItem, Select } from "@mui/material";
import { FORM_STYLES } from "../../constants";
import CustomIconComponent from "../CustomDropdownIcon";

type Props = {
  isOpen?: boolean;
  onClose?: () => void;
  osdNumber?: number;
  setPhotoProNumber?: (proNumber: number | undefined) => void;
  proNumbersOptions?: number[];
};

const PhotoModal: React.FC<Props> = ({
  isOpen,
  onClose,
  osdNumber,
  setPhotoProNumber,
  proNumbersOptions = [],
}: Props): JSX.Element => {
  const [proNumber, setProNumber] = React.useState<string>("");

  const handleDownload = useCallback(async () => {
    setPhotoProNumber?.(Number(proNumber));
    setProNumber("");
  }, [proNumber, setPhotoProNumber]);

  return (
    <div>
      <Dialog
        open={isOpen!}
        aria-labelledby="customized-dialog-title"
        keepMounted
        maxWidth="sm"
        fullWidth={true}
        className="assignment"
        data-testid="photo-dialog"
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="customized-dialog-title"
          className="modal-header"
          data-testid="dialog-title"
        >
          <Box display="flex" alignItems="center" gap={1}>
            Photos for OSD #{osdNumber}
          </Box>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 15,
            top: 15,
            color: (theme: any) => theme.palette.grey[500],
          }}
          data-testid="close-button"
        >
          <CloseIcon />
        </IconButton>
        <DialogContent
          dividers
          className="assignment-area"
          data-testid="dialog-content"
        >
          <Grid item md={3} xs={9}>
            <FormControl fullWidth size="small" className="custom-width">
              <InputLabel
                style={{ fontSize: "13px" }}
                shrink={true}
                id="proNumber"
              >
                PRO # <sup>*</sup>
              </InputLabel>
              <Select
                variant="outlined"
                id="date"
                placeholder="Select a Date"
                className="select"
                value={proNumber}
                fullWidth
                onChange={(e) => setProNumber(e.target.value)}
                style={FORM_STYLES.LABEL}
                IconComponent={CustomIconComponent}
              >
                {proNumbersOptions.map((obj: number) => (
                  <MenuItem style={FORM_STYLES.LABEL} key={obj} value={obj}>
                    {obj}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Button
              onClick={proNumber ? handleDownload : void 0}
              variant="contained"
              data-testid="download-button"
              className={
                proNumber
                  ? "entry photo-download-margin"
                  : "disable disable-btn entry photo-download-margin"
              }
            >
              Submit
            </Button>

            <Button
              onClick={onClose}
              variant="contained"
              data-testid="cancel-button"
              className="disable"
            >
              Cancel
            </Button>
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default PhotoModal;
